import { Typography } from '@material-ui/core';
import styled from 'styled-components';

const Text = styled(Typography)`
  text-transform: capitalize;
`;

export { Text };
